import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import {
    Card,
    Table,
    Stack,
    Button,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    TableHead,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections

import { Link as RouterLink } from 'react-router-dom';
// mock
import { useParams } from 'react-router-dom';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import Loader from 'src/components/loader/loader';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ExportStaticstical_checking from 'src/components/modal/ExportStaticstical_checking';
import EmtyData from 'src/components/emty-data';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function StaticticalCheck() {
    const params = useParams();
    const arrFillters = useRef([]);
    const { t } = useTranslation();
    const [getFlags, setGetFlags] = useState(false);
    const [tableDataHis, setTableDataHis] = useState([]);
    const delFlags = useRef(false);
    // const [deleleFlags, setDeleleFlags] = useState(false);
    const [visible, setVisible] = useState(false);
    const chekcRef = useRef(false);
    const [isChecked, setIsChecked] = useState(true);

    const getRef = useRef(false);
    const [tableData, setTableData] = useState([]);
    const tableRef = useRef(null);
    const dataHis = useRef([
        // staff
        t('day_event'),
        t('name_staff'),
        t('username'),
        t('Email'),
        t('phone_supplier'),
        t('department'),
        t('group_staff'),
        // device
        t('name_device'),
        t('code_device'),
        t('supplier'),
        t('code_supplier'),
        t('persitional'),
        t('Email'),
        t('phone_supplier') + ' ' + t('supplier'),
        t('address_supplier') + ' ' + t('supplier'),
        t('producer'),
        t('department'),
        t('price') + ' ' + t('device'),
        t('status') + ' ' + t('device'),
        t('property'),
        t('name_cabinet'),
        t('code_cabinet'),
        t('name_drawer'),
        'ID' + ' ' + t('drawer'),
        t('row'),
        t('column'),
        t('status'),
        t('quantity_category'),
        t('note_'),
        t('group_staff'),
    ]);

    const TABLE_HEAD = [
        { id: 'name', label: t('statictical_checker'), alignRight: false },
        { id: 'Thao tác', label: t('start_day'), alignRight: false },
        { id: '', label: t('end_day'), alignRight: false },
    ];

    useEffect(() => {
        setTimeout(() => {
            getData();
            checkStaticticalChecking();
        }, 1000);
    }, []);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [];
        sendRequest(serviceList.getStatisticsHistory, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableDataHis(message.proc_data.rows[0].o_1);
            arrFillters.current = message.proc_data.rows[0].o_1;
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
    };

    // check kiem ke
    const checkStaticticalChecking = useCallback(() => {
        if (chekcRef.current) {
            return;
        }
        chekcRef.current = true;
        const InVal = [1];
        sendRequest(
            serviceList.checkStatisticChecking,
            InVal,
            checkStaticticalCheckingResult,
            true,
            timeOutFunctcheckStaticticalChecking,
            40000
        );
    }, []);

    const checkStaticticalCheckingResult = (reqInfoMap, message) => {
        console.log('message', message);

        chekcRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setIsChecked(
                message.proc_data.rows[0].o_1[0] && message.proc_data.rows[0].o_1[0].check_inv_status === '0'
                    ? false
                    : true
            );
        }
    };

    const timeOutFunctcheckStaticticalChecking = (reqInfo) => {
        chekcRef.current = false;
        // toast.error(t('error.time_out'));
    };

    const handleSetStaticticalCheck = () => {
        // if (!dataAction.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        // setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [isChecked ? '0' : '1'];
        sendRequest(serviceList.setStatisticChecking, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        // setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // toast.success(message['proc_message']);
            checkStaticticalChecking();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        // setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };
    // console.log(tableData);

    return (
        <>
            <Helmet>
                <title> {t('history_checking')} </title>
            </Helmet>
            <ExportStaticstical_checking
                tableData={tableData}
                setTableData={setTableData}
                setVisible={setVisible}
                visible={visible}
                tableRef={tableRef}
            />

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('history_checking')}
                    </Typography>
                    <Loader loading={getFlags} />
                    <Stack spacing={1} direction="row" alignItems="center" justifyContent="space-between">
                        <Button
                            variant="contained"
                            disabled={isChecked}
                            component={RouterLink}
                            to={`/home/statictical-check/${params.idPermission}/export-staticstical`}
                            startIcon={<Iconify icon="material-symbols:table-chart-view-rounded" />}
                            // onClick={() => navigate(`statictical-check/${params.idPermisstion}/export-staticstical`)}
                        >
                            {t('export_inventory')}
                        </Button>{' '}
                        <Button
                            variant="contained"
                            startIcon={
                                <Iconify
                                    icon={
                                        !isChecked
                                            ? 'material-symbols:lock'
                                            : 'material-symbols:lock-open-right-rounded'
                                    }
                                />
                            }
                            onClick={handleSetStaticticalCheck}
                        >
                            {isChecked ? t('on') + ' ' + t('lock_repoet') : t('off') + ' ' + t('lock_repoet')}
                        </Button>{' '}
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="material-symbols:nest-clock-farsight-analog-outline-rounded" />}
                            onClick={() => setVisible(true)}
                        >
                            {t('history_cabinet')}
                        </Button>
                    </Stack>
                </Stack>
                <Breadcrumb paths={[{ label: t('lock_repoet'), url: '#', navigate: false }]} />
                <Card sx={{ padding: 2 }}>
                    <TableContainer sx={{}}>
                        <Table>
                            <DepartmentListHead headLabel={TABLE_HEAD} />
                            <TableBody>
                                {tableDataHis.length > 0 &&
                                    tableDataHis.map((item) => {
                                        return (
                                            <TableRow
                                                hover
                                                key={item.id}
                                                tabIndex={-1}
                                                role="checkbox"
                                                // selected={selectedUser}
                                            >
                                                <TableCell padding="checkbox"></TableCell>

                                                <TableCell align="left">{item.user_nm}</TableCell>

                                                <TableCell>
                                                    {' '}
                                                    {glb_sv.formatDate(item.history_time_str, 'YYYYMMDDHHmmss')}
                                                </TableCell>
                                                <TableCell>
                                                    {glb_sv.formatDate(item.history_time_end, 'YYYYMMDDHHmmss')}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                        {tableDataHis.length === 0 && <EmtyData />}
                    </TableContainer>
                </Card>

                <TableContainer sx={{}} style={{ display: 'none' }}>
                    <Table ref={tableRef}>
                        <TableHead>
                            <TableRow>
                                {dataHis.current &&
                                    dataHis.current.map((header, index) => {
                                        return <TableCell key={index}>{header}</TableCell>;
                                    })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.length > 0 &&
                                tableData.map((item, index) => {
                                    return (
                                        <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                            <TableCell padding="checkbox">
                                                {glb_sv.formatDate(item.transaction_dt, 'YYYYMMDDHHmmss')}
                                            </TableCell>

                                            <TableCell align="left">{item?.user_nm}</TableCell>
                                            <TableCell align="left">{item?.accounts}</TableCell>
                                            <TableCell align="left">{item?.email}</TableCell>
                                            <TableCell align="left">{item?.phone}</TableCell>
                                            <TableCell align="left">{item?.departs_nm}</TableCell>
                                            <TableCell align="left">{item?.group_user}</TableCell>
                                            <TableCell align="left">
                                                {glb_sv.convertMultipleLanguages(item?.device_nm)}
                                            </TableCell>
                                            <TableCell align="left">{item?.device_cd}</TableCell>
                                            <TableCell align="left">{item?.supplier_nm}</TableCell>
                                            <TableCell align="left">{item?.supplier_cd}</TableCell>
                                            <TableCell align="left">{item?.auth_rep}</TableCell>

                                            <TableCell align="left">{item?.supplier_email}</TableCell>
                                            <TableCell align="left">{item?.supplier_phone}</TableCell>
                                            <TableCell align="left">{item?.address}</TableCell>
                                            <TableCell align="left">
                                                {item?.producer?.length > 0 &&
                                                    item.producer.map((producer) => {
                                                        let str = '';
                                                        str += producer.label + ', ';
                                                        return str;
                                                    })}
                                            </TableCell>
                                            <TableCell align="left">
                                                {item?.depart_id?.length > 0 &&
                                                    item.depart_id.map((depart) => {
                                                        let str = '';
                                                        str += depart.label + ', ';
                                                        return str;
                                                    })}
                                            </TableCell>
                                            <TableCell align="left">{item?.price}</TableCell>
                                            <TableCell align="left">
                                                {item?.status_action === '1' ? t('take') : t('borrowing')}
                                            </TableCell>
                                            <TableCell align="left">
                                                {item?.properties_device?.length > 0 &&
                                                    item.properties_device.map((property) => {
                                                        let str = '';
                                                        str += property?.label + ': ' + property?.value + ', ';
                                                        return str;
                                                    })}
                                            </TableCell>
                                            <TableCell align="left">{item?.cabinet_nm}</TableCell>
                                            <TableCell align="left">{item?.cabinet_cd}</TableCell>
                                            <TableCell align="left">{item?.drawer_nm}</TableCell>
                                            <TableCell align="left">{item?.drawer_lc}</TableCell>
                                            <TableCell align="left">{item?.cell_row}</TableCell>
                                            <TableCell align="left">{item?.cell_column}</TableCell>
                                            <TableCell align="left">
                                                {item?.status === '7'
                                                    ? item?.bussiness === 'rde'
                                                        ? t('admin_progresing_fixed')
                                                        : t('admin_progresing')
                                                    : item?.key_mean_status !== ''
                                                    ? item?.key_mean_status
                                                    : item?.key_mean}
                                            </TableCell>
                                            <TableCell align="left">{item?.qty}</TableCell>
                                            <TableCell align="left">{item?.note ? item.note : '--/--'}</TableCell>
                                            <TableCell align="left">
                                                {item?.group_user ? item.group_user : '--/--'}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
        </>
    );
}
